export default "__VITE_ASSET__a08fb440__"